import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/alodata/src/components/ClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/var/www/alodata/src/context/LanguageContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationsProvider"] */ "/var/www/alodata/src/context/TranslationsContext.tsx");
